<template>
	<div class="container">
		<div class="row">
			<div class="col col-login mx-auto">
				<div class="text-center mb-4">
					<img src="assets/images/logo.svg" class="h-7" alt="">
				</div>
				<form class="card" id="dash-form" @submit.prevent="submitLoginForm">
					<div class="card-body p-6">
						<div class="card-title text-center">Login to your account</div>
						<div class="form-group alert alert-danger" role="alert">
							Incorrect Credentials
						</div>
						<div class="form-group">
							<label class="form-label">Email Address</label>
							<input type="email" name="email" v-model="email" class="form-control" placeholder="Enter email" v-validate="'required|email'">
							<small class="d-block text-danger">{{ errors.first('email') }}</small>
						</div>
						<div class="form-group">
							<label class="form-label">
								Password
							</label>
							<input type="password" name="password" v-model="password" class="form-control" placeholder="Password" v-validate="'required'">
							<small class="d-block text-danger">{{ errors.first('password') }}</small>
						</div>
						<div class="form-footer">
							<button type="submit" id="login" class="btn btn-primary btn-block">Sign in</button>
							<button type="button" id="google-login" class="btn btn-secondary btn-block d-flex justify-content-center align-items-center" @click="GoogleSignIn"><img class="google-g mr-2" src="/assets/images/google-g.svg" alt="G">Sign in with Google</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import firebase from 'firebase/app'
import "firebase/auth";
import { mapActions } from 'vuex'

export default {
	name: 'login',
	data() {
		return {
			email: "",
			password: ""
		}
	},
	mounted() {
		// Hide loader
		this.$store.dispatch('setLoading', false);
		// Logout whenever /login is hit
		this.logout();
	},
	methods: {
		logout: function() {
			let self = this;

			firebase.auth().signOut().then(function() {
				// Sign-out successful.
				// Set store login flag
				self.$store.dispatch('setCurrentUser', null);
				setTimeout(function() {
					// Remove objects from firebaseWatchers
					self.$store.dispatch('resetFirebaseWatchers');
				}, 50);
			}).catch(function(error) {
				// An error happened.
				self.showToast(error.message);
			});
		},
		submitLoginForm: function() {
			let self = this;
			// Check Vee Validate
			self.$validator.validateAll().then((result) => {
				if (result) {
					// Show loader
					this.$store.dispatch('setLoading', true);
					// Login with creds
					firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(function(result) {
						// Login successful.
						self.showToast("Login Successful");
						// Redirect to home
						self.$router.push('/');
						// Set store user object
						self.$store.dispatch('setCurrentUser', result['user']);
						// Hide loader
						self.$store.dispatch('setLoading', false);
					}).catch(function(error) {
						// An error happened.
						self.showToast(error.message);
						// Hide loader
						self.$store.dispatch('setLoading', false);
					});
					
					return;
				}
			});
		},
		GoogleSignIn: function() {
			let self = this,
				provider = new firebase.auth.GoogleAuthProvider();

			firebase.auth().signInWithPopup(provider).then(function(result) {
				if(result['user']['email'].endsWith('radix.email')) {
					// Login successful.
					self.showToast("Login Successful");
					// Redirect to home
					self.$router.push('/');
					// Set login token
					self.$store.dispatch('setLoginToken', result.credential.accessToken);
					// Set store user object
					self.$store.dispatch('setCurrentUser', result['user']);
					// Hide loader
					self.$store.dispatch('setLoading', false);
				}
				else {
					// Login unsuccessful.
					self.showToast("Access Restricted to 'radix.email'");
					// Logout when not 'radix.email'
					self.logout();
				}
			}).catch(function(error) {
				// An error happened.
				self.showToast(error.message);
				// Hide loader
				self.$store.dispatch('setLoading', false);
			});
		},
	}
}
</script>

<style lang="scss">
.google-g {
	height: 20px;
	width: 20px;
}
</style>
